import { Link, Outlet } from "react-router-dom";
import Logo from "@/assets/Logo.svg";
import { ListTodo, LogOut, User } from "lucide-react";
import { useKeycloak } from "@/store/KeycloakProvider.tsx";
import { useDialog } from "@/hook/useDialog.ts";
import PACKAGE from "../../package.json";
import { EndpointEnum } from "@/enum/EndpointEnum.ts";
import { ReadBackendVersionResDto } from "@/dto/ReadBackendVersionDto.ts";
import { EmptyDto } from "@/dto/CommonDto.ts";
import useGetQuery from "@/hook/useGetQuery.ts";

export function Header() {
    const { logout, user } = useKeycloak();
    const { openConfirm } = useDialog();

    const { data } = useGetQuery<EmptyDto, ReadBackendVersionResDto>(EndpointEnum.READ_BE_VERSION);
    const handleLogout = () => {
        openConfirm("로그아웃 하시겠습니까?", () => {
            logout();
        });
    };
    return (
        <>
            <header className="w-full min-h-[4rem] px-4 md:px-10 py-4 md:py-6 flex justify-between bg-white items-center">
                <div className="flex items-center gap-2">
                    <Link to="/" className="h-6 md:h-8 lg:h-10">
                        <img src={Logo} alt="Logo" className="h-full w-auto" />
                    </Link>
                    <ul>
                        <li>
                            <small className="text-brand self-end ">FE {PACKAGE.version}</small>
                        </li>
                        <li>
                            <small className="text-brand self-end ">BE {data && "error" in data ? "-" : data?.version || "-"}</small>
                        </li>
                    </ul>
                </div>
                <nav>
                    <ul className="flex items-center gap-4 md:gap-6">
                        <li>
                            <Link to="/inspections" className="flex flex-col items-center gap-1 text-gray-600 hover:text-brand transition-colors duration-200">
                                <ListTodo className="w-5 h-5 md:w-6 md:h-6" />
                                <span className="hidden md:block text-sm">전체 목록</span>
                            </Link>
                        </li>
                        <li>
                            <div className="flex flex-col items-center gap-1 text-gray-600 transition-colors duration-200">
                                <User className="w-5 h-5 md:w-6 md:h-6" />
                                <span className="hidden md:block text-sm">{user?.name}</span>
                            </div>
                        </li>
                        <li>
                            <button onClick={handleLogout} className="flex flex-col items-center gap-1 text-gray-600 hover:text-red-500 transition-colors duration-200">
                                <LogOut className="w-5 h-5 md:w-6 md:h-6" />
                                <span className="hidden md:block text-sm">로그아웃</span>
                            </button>
                        </li>
                    </ul>
                </nav>
            </header>
            <Outlet />
        </>
    );
}